// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Table,
//   Button,
//   Form,
//   Modal,
//   InputGroup,
//   Pagination,
//   Badge,
//   Spinner,
// } from "react-bootstrap";
// import ConfirmModal from "../../components/common/ConfirmModal";
// import api from "../../api";
// import Can from "../../components/Can";
// import ProjectMemberPicker from "../../components/ProjectMemberPicker";
// import { usePermissions } from "../../context/PermissionContext";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./ProjectManagementPage.css";
// import { getSerialNumber } from "../../utils/pagination";
// import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";

// const STATUS_VALUES = ["PLANNED", "ACTIVE", "ON_HOLD", "COMPLETED", "ARCHIVED", "CANCELLED"];

// const initialForm = {
//   name: "",
//   code: "",
//   description: "",
//   owner_user_id: "",
//   department_id: "",
//   unit_id: "",
//   start_date: "",
//   end_date: "",
// };

// const statusColor = (status) => {
//   switch (status) {
//     case "ACTIVE": return "success";
//     case "PLANNED": return "info";
//     case "ON_HOLD": return "warning";
//     case "COMPLETED": return "primary";
//     case "CANCELLED": return "danger";
//     case "ARCHIVED": return "secondary";
//     default: return "secondary";
//   }
// };

// export default function ProjectManagementPage() {
//   const { can } = usePermissions();
//   const navigate = useNavigate();

//   const [projects, setProjects] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [units, setUnits] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [users, setUsers] = useState([]);

//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const [activeFilter, setActiveFilter] = useState("");
//   const [departmentFilter, setDepartmentFilter] = useState("");
//   const [unitFilter, setUnitFilter] = useState("");
//   const [ownerFilter, setOwnerFilter] = useState("");

//   const [sortField, setSortField] = useState("name");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);

//   const [loading, setLoading] = useState(false);
//   const [loadError, setLoadError] = useState(null);
//   const [saving, setSaving] = useState(false);

//   const [form, setForm] = useState(initialForm);
//   const [editId, setEditId] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [archiveTarget, setArchiveTarget] = useState(null);
//   const [archiving, setArchiving] = useState(false);

//   useEffect(() => {
//     fetchDropdownData();
//   }, []);

//   useEffect(() => {
//     fetchProjects();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search, statusFilter, activeFilter, departmentFilter, unitFilter, ownerFilter, sortField, sortOrder, currentPage, pageSize]);

//   const fetchDropdownData = async () => {
//     try {
//       const [unitRes, deptRes, userRes] = await Promise.all([
//         api.get("/units"),
//         api.get("/departments", { params: { is_active: 1, pageSize: 200 } }),
//         api.get("/users"),
//       ]);
//       setUnits(Array.isArray(unitRes.data) ? unitRes.data : []);
//       setDepartments(Array.isArray(deptRes.data?.data) ? deptRes.data.data : []);
//       setUsers(Array.isArray(userRes.data) ? userRes.data : []);
//     } catch (err) {
//       console.error("Dropdown fetch error:", err);
//     }
//   };

//   const fetchProjects = async () => {
//     try {
//       setLoading(true);
//       setLoadError(null);
//       const res = await api.get("/projects", {
//         params: {
//           search: search || undefined,
//           status: statusFilter || undefined,
//           is_active: activeFilter === "" ? undefined : activeFilter,
//           department_id: departmentFilter || undefined,
//           unit_id: unitFilter || undefined,
//           owner_user_id: ownerFilter || undefined,
//           sortField,
//           sortOrder,
//           page: currentPage,
//           pageSize,
//         },
//       });

//       // Backend envelope is always { success, data: [...], meta: { total,
//       // page, pageSize } } (see controllers/projectController.js#getProjects)
//       // -- if that shape isn't there, treat it as a malformed response
//       // rather than silently rendering an empty list.
//       if (res.data?.success === false || !Array.isArray(res.data?.data)) {
//         throw new Error(res.data?.message || "Unexpected response shape from /projects");
//       }

//       setProjects(res.data.data);
//       setTotal(res.data?.meta?.total ?? res.data.data.length);
//     } catch (err) {
//       console.error("Fetch projects error:", err);
//       const message = err.response?.data?.message || err.message || "Failed to fetch projects";
//       setProjects([]);
//       setTotal(0);
//       setLoadError(message);
//       toast.error(message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

//   const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

//   const openAdd = () => {
//     setForm(initialForm);
//     setEditId(null);
//     setShowModal(true);
//   };

//   const openEdit = (project) => {
//     setForm({
//       name: project.name || "",
//       code: project.code || "",
//       description: project.description || "",
//       owner_user_id: project.owner_user_id || "",
//       department_id: project.department_id || "",
//       unit_id: project.unit_id || "",
//       start_date: project.start_date ? String(project.start_date).slice(0, 10) : "",
//       end_date: project.end_date ? String(project.end_date).slice(0, 10) : "",
//     });
//     setEditId(project.id);
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setEditId(null);
//     setForm(initialForm);
//   };

//   const handleSave = async () => {
//     if (!form.name.trim()) {
//       toast.warning("Project name is required");
//       return;
//     }

//     const payload = {
//       name: form.name.trim(),
//       code: form.code.trim() || undefined,
//       description: form.description.trim() || null,
//       owner_user_id: form.owner_user_id || null,
//       department_id: form.department_id || null,
//       unit_id: form.unit_id || null,
//       start_date: form.start_date || null,
//       end_date: form.end_date || null,
//     };

//     try {
//       setSaving(true);
//       if (editId) {
//         await api.put(`/projects/${editId}`, payload);
//         toast.success("Project updated");
//       } else {
//         await api.post("/projects", payload);
//         toast.success("Project created");
//       }
//       closeModal();
//       fetchProjects();
//     } catch (err) {
//       console.error("Save project error:", err);
//       toast.error(err.response?.data?.message || "Failed to save project");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const toggleActive = async (project) => {
//     try {
//       await api.patch(`/projects/${project.id}/active-status`, { is_active: !project.is_active });
//       toast.success(project.is_active ? "Project deactivated" : "Project activated");
//       fetchProjects();
//     } catch (err) {
//       console.error("Toggle active error:", err);
//       toast.error(err.response?.data?.message || "Failed to update status");
//     }
//   };

//   const confirmArchive = async () => {
//     if (!archiveTarget) return;
//     setArchiving(true);
//     try {
//       await api.patch(`/projects/${archiveTarget.id}/status`, { status: "ARCHIVED" });
//       toast.success("Project archived");
//       setArchiveTarget(null);
//       fetchProjects();
//     } catch (err) {
//       console.error("Archive project error:", err);
//       toast.error(err.response?.data?.message || "Failed to archive project");
//     } finally {
//       setArchiving(false);
//     }
//   };

//   const openDeleteModal = (project) => {
//     setDeleteTarget(project);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteTarget(null);
//     setShowDeleteModal(false);
//   };

//   const confirmDelete = async () => {
//     if (!deleteTarget) return;
//     try {
//       await api.delete(`/projects/${deleteTarget.id}`);
//       toast.success("Project deleted");
//       closeDeleteModal();
//       fetchProjects();
//     } catch (err) {
//       console.error("Delete project error:", err);
//       const data = err.response?.data;
//       if (data?.code === "PROJECT_IN_USE") {
//         const d = data.details?.dependents || {};
//         toast.error(`Cannot delete: ${d.members || 0} member(s), ${d.modules || 0} module(s) reference it. Archive or deactivate instead.`);
//       } else {
//         toast.error(data?.message || "Failed to delete project");
//       }
//       closeDeleteModal();
//     }
//   };

//   return (
//     <div className="unit-page proj-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>Project Management</h2>
//           <p>Manage projects, ownership and lifecycle. Task classification/assignment come in a later phase.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchProjects}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Can moduleKey="projects" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add Project
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="proj-stat-icon proj-stat-icon-primary">
//             <i className="fa-solid fa-folder-open" aria-hidden="true"></i>
//           </div>
//           <div className="proj-stat-text">
//             <span>Total Projects</span>
//             <strong>{total}</strong>
//           </div>
//         </div>
//         <div className="unit-stat-card">
//           <div className="proj-stat-icon proj-stat-icon-accent">
//             <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
//           </div>
//           <div className="proj-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-diagram-project proj-list-icon" aria-hidden="true"></i>
//               Project List
//             </h5>
//             <p>Search, filter, add, update, activate/deactivate, archive or delete projects.</p>
//           </div>

//           <div className="unit-toolbar-actions proj-filters-row">
//             <InputGroup className="unit-search proj-search">
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search name or code..."
//                 aria-label="Search name or code"
//                 value={search}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setSearch(e.target.value);
//                 }}
//               />
//             </InputGroup>

//             <div className="proj-select-wrap">
//               <i className="fa-solid fa-circle-check proj-select-icon" aria-hidden="true"></i>
//               <Form.Select
//                 className="proj-filter-select"
//                 aria-label="Filter by status"
//                 value={statusFilter}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setStatusFilter(e.target.value);
//                 }}
//               >
//                 <option value="">All Statuses</option>
//                 {STATUS_VALUES.map((s) => (
//                   <option key={s} value={s}>{s.replace("_", " ")}</option>
//                 ))}
//               </Form.Select>
//             </div>

//             <Form.Select
//               className="proj-filter-select proj-filter-select-plain"
//               aria-label="Filter by active status"
//               value={activeFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setActiveFilter(e.target.value);
//               }}
//             >
//               <option value="">Active: Any</option>
//               <option value="1">Active</option>
//               <option value="0">Inactive</option>
//             </Form.Select>

//             <Form.Select
//               className="proj-filter-select proj-filter-select-plain"
//               aria-label="Filter by department"
//               value={departmentFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setDepartmentFilter(e.target.value);
//               }}
//             >
//               <option value="">All Departments</option>
//               {departments.map((d) => (
//                 <option key={d.id} value={d.id}>{d.name}</option>
//               ))}
//             </Form.Select>

//             <Form.Select
//               className="proj-filter-select proj-filter-select-plain"
//               aria-label="Filter by unit"
//               value={unitFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setUnitFilter(e.target.value);
//               }}
//             >
//               <option value="">All Units</option>
//               {units.map((u) => (
//                 <option key={u.id} value={u.id}>{u.name}</option>
//               ))}
//             </Form.Select>

//             <Form.Select
//               className="proj-filter-select proj-filter-select-plain"
//               aria-label="Filter by owner"
//               value={ownerFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setOwnerFilter(e.target.value);
//               }}
//             >
//               <option value="">All Owners</option>
//               {users.map((u) => (
//                 <option key={u.id} value={u.id}>{u.name}</option>
//               ))}
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size"
//               aria-label="Rows per page"
//               value={pageSize}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setPageSize(Number(e.target.value));
//               }}
//             >
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading projects...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: 70 }}>S.NO.</th>
//                   <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>
//                   <th className="sortable" onClick={() => handleSort("code")}>Code {sortIcon("code")}</th>
//                   <th>Owner</th>
//                   <th>Department</th>
//                   <th>Unit</th>
//                   <th className="sortable" onClick={() => handleSort("status")}>Status {sortIcon("status")}</th>
//                   <th>Members</th>
//                   <th>Modules</th>
//                   <th className="sortable" onClick={() => handleSort("is_active")}>Active {sortIcon("is_active")}</th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {loadError ? (
//                   <tr>
//                     <td colSpan="11">
//                       <div className="unit-empty unit-empty-error">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
//                         </div>
//                         <h5>Couldn't load projects</h5>
//                         <p>{loadError}</p>
//                         <Button className="unit-btn unit-btn-light" onClick={fetchProjects}>
//                           Retry
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : projects.length > 0 ? (
//                   projects.map((project, index) => (
//                     <tr key={project.id}>
//                       <td>{getSerialNumber(index, currentPage, pageSize)}</td>
//                       <td>
//                         <Button
//                           variant="link"
//                           className="p-0 proj-name-link"
//                           onClick={() => navigate(`/admin/projects/${project.id}`)}
//                         >
//                           <strong>{project.name}</strong>
//                         </Button>
//                       </td>
//                       <td>{project.code}</td>
//                       <td>{project.owner_name || <span className="proj-muted">—</span>}</td>
//                       <td>{project.department_name || <span className="proj-muted">—</span>}</td>
//                       <td>{project.unit_name || <span className="proj-muted">—</span>}</td>
//                       <td>
//                         <Badge bg={statusColor(project.status)}>{project.status}</Badge>
//                       </td>
//                       <td className="proj-col-count">{project.active_member_count ?? 0}</td>
//                       <td className="proj-col-count">{project.active_module_count ?? 0}</td>
//                       <td>
//                         <Badge bg={project.is_active ? "success" : "secondary"}>
//                           {project.is_active ? "Active" : "Inactive"}
//                         </Badge>
//                       </td>
//                       <td>
//                         <div className="unit-actions">
//                           <Button
//                             className="unit-icon-btn"
//                             title="View Details"
//                             aria-label="View project"
//                             onClick={() => navigate(`/admin/projects/${project.id}`)}
//                           >
//                             <i className="fa-solid fa-eye" aria-hidden="true"></i>
//                           </Button>

//                           <Can moduleKey="projects" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit"
//                               aria-label="Edit project"
//                               onClick={() => openEdit(project)}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           {(can("projects", "activate") || can("projects", "deactivate")) && (
//                             <Button
//                               className="unit-icon-btn proj-toggle"
//                               title={project.is_active ? "Deactivate" : "Activate"}
//                               aria-label={project.is_active ? "Deactivate project" : "Activate project"}
//                               onClick={() => toggleActive(project)}
//                             >
//                               <i className={`fa-solid ${project.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
//                             </Button>
//                           )}

//                           <Can moduleKey="projects" actionKey="archive">
//                             {project.status !== "ARCHIVED" && (
//                               <Button
//                                 className="unit-icon-btn proj-archive"
//                                 title="Archive"
//                                 aria-label="Archive project"
//                                 onClick={() => setArchiveTarget(project)}
//                               >
//                                 <i className="fa-solid fa-box-archive" aria-hidden="true"></i>
//                               </Button>
//                             )}
//                           </Can>

//                           <Can moduleKey="projects" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title="Delete"
//                               aria-label="Delete project"
//                               onClick={() => openDeleteModal(project)}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="11">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-diagram-project" aria-hidden="true"></i>
//                         </div>
//                         <h5>No projects found</h5>
//                         <p>Try another search or add a new project.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing <strong>{projects.length}</strong> of <strong>{total}</strong> projects
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
//                   {i + 1}
//                 </Pagination.Item>
//               ))}
//               <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={showModal}
//         onHide={closeModal}
//         centered
//         className="unit-modal"
//         size="lg"
//         dialogClassName="admin-teal-modal admin-teal-modal-lg"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <div className="d-flex align-items-center">
//             <FolderOutlinedIcon className="modal-header-icon" aria-hidden="true" />
//             <Modal.Title>{editId ? "Edit Project" : "Add New Project"}</Modal.Title>
//           </div>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="row g-3">
//             <div className="col-md-6">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g. Website Revamp"
//                 value={form.name}
//                 onChange={(e) => handleChange("name", e.target.value)}
//               />
//             </div>

//             <div className="col-md-6">
//               <Form.Label>Code (optional — derived from name if blank)</Form.Label>
//               <Form.Control
//                 placeholder="e.g. WEB_REVAMP"
//                 value={form.code}
//                 onChange={(e) => handleChange("code", e.target.value)}
//               />
//             </div>

//             <div className="col-md-12">
//               <Form.Label>Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 value={form.description}
//                 onChange={(e) => handleChange("description", e.target.value)}
//               />
//             </div>

//             <div className="col-md-6">
//               <Form.Label>Owner (optional)</Form.Label>
//               <ProjectMemberPicker
//                 users={users}
//                 value={form.owner_user_id}
//                 onChange={(id) => handleChange("owner_user_id", id)}
//                 placeholder="Select project owner..."
//               />
//               <Form.Text muted>
//                 The owner is automatically given an active OWNER membership on this project.
//               </Form.Text>
//             </div>

//             <div className="col-md-3">
//               <Form.Label>Department (optional)</Form.Label>
//               <Form.Select value={form.department_id} onChange={(e) => handleChange("department_id", e.target.value)}>
//                 <option value="">Unclassified</option>
//                 {departments.map((d) => (
//                   <option key={d.id} value={d.id}>{d.name}</option>
//                 ))}
//               </Form.Select>
//             </div>

//             <div className="col-md-3">
//               <Form.Label>Unit (optional)</Form.Label>
//               <Form.Select value={form.unit_id} onChange={(e) => handleChange("unit_id", e.target.value)}>
//                 <option value="">Global</option>
//                 {units.map((u) => (
//                   <option key={u.id} value={u.id}>{u.name}</option>
//                 ))}
//               </Form.Select>
//             </div>

//             <div className="col-md-6">
//               <Form.Label>Start Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 value={form.start_date}
//                 onChange={(e) => handleChange("start_date", e.target.value)}
//               />
//             </div>

//             <div className="col-md-6">
//               <Form.Label>End Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 value={form.end_date}
//                 onChange={(e) => handleChange("end_date", e.target.value)}
//               />
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-primary" onClick={handleSave} disabled={saving}>
//             {saving ? "Saving..." : editId ? "Update Project" : "Create Project"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={showDeleteModal}
//         onHide={closeDeleteModal}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal admin-teal-modal-sm admin-teal-modal-danger"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <Modal.Title>Delete Project?</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="admin-modal-danger-icon" aria-hidden="true">
//             <DeleteOutlineIcon fontSize="inherit" />
//           </div>
//           <p className="unit-delete-text text-center">
//             Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
//             If members or modules reference it, deletion will be blocked — archive or deactivate instead.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>Delete</Button>
//         </Modal.Footer>
//       </Modal>

//       <ConfirmModal
//         show={!!archiveTarget}
//         onHide={() => setArchiveTarget(null)}
//         onConfirm={confirmArchive}
//         busy={archiving}
//         title="Archive Project?"
//         message={`Archive project "${archiveTarget?.name}"? Archived projects are kept for history but treated as closed.`}
//         confirmLabel="Archive"
//         confirmVariantClass="unit-btn-primary"
//         dialogClassName="admin-teal-modal admin-teal-modal-sm"
//         icon={<ArchiveOutlinedIcon fontSize="inherit" />}
//         iconClassName="admin-modal-deactivate-icon"
//       />
//     </div>
//   );
// }




import React, { useContext, useEffect, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  Table,
  Button,
  Form,
  Modal,
  InputGroup,
  Pagination,
  Badge,
  Spinner,
} from "react-bootstrap";
import ConfirmModal from "../../components/common/ConfirmModal";
import api from "../../api";
import Can from "../../components/Can";
import { AuthContext } from "../../context/AuthContext";
import ProjectMemberPicker from "../../components/ProjectMemberPicker";
import ProjectDetailPanel from "./ProjectDetailPanel";
import ProjectDependencyModal from "./ProjectDependencyModal";
import { usePermissions } from "../../context/PermissionContext";
import { toast } from "react-toastify";
import "./ProjectManagementPage.css";
import { getSerialNumber } from "../../utils/pagination";

const STATUS_VALUES = ["PLANNED", "ACTIVE", "ON_HOLD", "COMPLETED", "ARCHIVED", "CANCELLED"];

const initialForm = {
  name: "",
  code: "",
  description: "",
  owner_user_id: "",
  department_id: "",
  unit_id: "",
  start_date: "",
  end_date: "",
};

const statusColor = (status) => {
  switch (status) {
    case "ACTIVE": return "success";
    case "PLANNED": return "info";
    case "ON_HOLD": return "warning";
    case "COMPLETED": return "primary";
    case "CANCELLED": return "danger";
    case "ARCHIVED": return "secondary";
    default: return "secondary";
  }
};

export default function ProjectManagementPage() {
  const { can } = usePermissions();
  const navigate = useNavigate();
  // Reused as-is at /developer/projects (routes/DynamicRoutes.jsx's shared
  // 'projects' entry) as well as /admin/projects (routes/AppRoutes.js) --
  // its own "open workspace" navigation must follow the CURRENT user's
  // role prefix, never a hardcoded /admin/..., same convention as
  // ProjectWorkspaceHeader.jsx / pages/tasks/TaskDetailPage.jsx.
  const { user } = useContext(AuthContext) || {};
  const isAdmin = user?.role === "admin";
  const basePath = `/${user?.role || "admin"}`;

  // Inline project workspace (Overview/Members/Modules/Module Members) --
  // driven by ?project=&tab= so it survives refresh and the browser back
  // button, per the "merge project detail into this page" requirement.
  // Only one project's workspace can be open at a time: opening a
  // different project just overwrites the `project` param.
  const [searchParams, setSearchParams] = useSearchParams();
  const expandedProjectId = searchParams.get("project");
  const expandedTab = searchParams.get("tab") || "overview";

  const openProjectWorkspace = (projectId, tab = "overview") => {
    const next = new URLSearchParams(searchParams);
    next.set("project", String(projectId));
    next.set("tab", tab);
    setSearchParams(next);
  };

  const collapseProjectWorkspace = () => {
    const next = new URLSearchParams(searchParams);
    next.delete("project");
    next.delete("tab");
    setSearchParams(next);
  };

  const toggleProjectWorkspace = (projectId) => {
    if (String(expandedProjectId) === String(projectId)) {
      collapseProjectWorkspace();
    } else {
      openProjectWorkspace(projectId, "overview");
    }
  };

  const handleWorkspaceTabChange = (tab) => openProjectWorkspace(expandedProjectId, tab);

  const [projects, setProjects] = useState([]);
  const [total, setTotal] = useState(0);
  const [units, setUnits] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [activeFilter, setActiveFilter] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [unitFilter, setUnitFilter] = useState("");
  const [ownerFilter, setOwnerFilter] = useState("");

  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [archiveTarget, setArchiveTarget] = useState(null);
  const [archiving, setArchiving] = useState(false);

  // Dependency-resolution modal ("Project Cannot Be Deleted") -- opened
  // instead of the old toast-only handling whenever DELETE /projects/:id
  // rejects with PROJECT_IN_USE. dependencyInitialCounts pre-fills the
  // counts from that error response so the modal paints instantly, before
  // the full GET /projects/:id/dependencies detail fetch resolves.
  const [dependencyTarget, setDependencyTarget] = useState(null);
  const [dependencyInitialCounts, setDependencyInitialCounts] = useState(null);
  const [showDependencyModal, setShowDependencyModal] = useState(false);
  // Bumped whenever a dependency is resolved (member removed, module
  // archived/deleted) so the inline Project Workspace row, if open for the
  // same project, remounts and refetches instead of showing stale data.
  const [workspaceRefreshTick, setWorkspaceRefreshTick] = useState(0);

  useEffect(() => {
    fetchDropdownData();
  }, []);

  useEffect(() => {
    fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, statusFilter, activeFilter, departmentFilter, unitFilter, ownerFilter, sortField, sortOrder, currentPage, pageSize]);

  const fetchDropdownData = async () => {
    try {
      const [unitRes, deptRes, userRes] = await Promise.all([
        api.get("/units"),
        api.get("/departments", { params: { is_active: 1, pageSize: 200 } }),
        api.get("/users"),
      ]);
      setUnits(Array.isArray(unitRes.data) ? unitRes.data : []);
      setDepartments(Array.isArray(deptRes.data?.data) ? deptRes.data.data : []);
      setUsers(Array.isArray(userRes.data) ? userRes.data : []);
    } catch (err) {
      console.error("Dropdown fetch error:", err);
    }
  };

  const fetchProjects = async () => {
    try {
      setLoading(true);
      setLoadError(null);
      const res = await api.get("/projects", {
        params: {
          search: search || undefined,
          status: statusFilter || undefined,
          is_active: activeFilter === "" ? undefined : activeFilter,
          department_id: departmentFilter || undefined,
          unit_id: unitFilter || undefined,
          owner_user_id: ownerFilter || undefined,
          sortField,
          sortOrder,
          page: currentPage,
          pageSize,
        },
      });

      // Backend envelope is always { success, data: [...], meta: { total,
      // page, pageSize } } (see controllers/projectController.js#getProjects)
      // -- if that shape isn't there, treat it as a malformed response
      // rather than silently rendering an empty list.
      if (res.data?.success === false || !Array.isArray(res.data?.data)) {
        throw new Error(res.data?.message || "Unexpected response shape from /projects");
      }

      setProjects(res.data.data);
      setTotal(res.data?.meta?.total ?? res.data.data.length);
    } catch (err) {
      console.error("Fetch projects error:", err);
      const message = err.response?.data?.message || err.message || "Failed to fetch projects";
      setProjects([]);
      setTotal(0);
      setLoadError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

  const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const openAdd = () => {
    setForm(initialForm);
    setEditId(null);
    setShowModal(true);
  };

  const openEdit = (project) => {
    setForm({
      name: project.name || "",
      code: project.code || "",
      description: project.description || "",
      owner_user_id: project.owner_user_id || "",
      department_id: project.department_id || "",
      unit_id: project.unit_id || "",
      start_date: project.start_date ? String(project.start_date).slice(0, 10) : "",
      end_date: project.end_date ? String(project.end_date).slice(0, 10) : "",
    });
    setEditId(project.id);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditId(null);
    setForm(initialForm);
  };

  const handleSave = async () => {
    if (!form.name.trim()) {
      toast.warning("Project name is required");
      return;
    }

    const payload = {
      name: form.name.trim(),
      code: form.code.trim() || undefined,
      description: form.description.trim() || null,
      owner_user_id: form.owner_user_id || null,
      department_id: form.department_id || null,
      unit_id: form.unit_id || null,
      start_date: form.start_date || null,
      end_date: form.end_date || null,
    };

    try {
      setSaving(true);
      if (editId) {
        await api.put(`/projects/${editId}`, payload);
        toast.success("Project updated");
      } else {
        await api.post("/projects", payload);
        toast.success("Project created");
      }
      closeModal();
      fetchProjects();
    } catch (err) {
      console.error("Save project error:", err);
      toast.error(err.response?.data?.message || "Failed to save project");
    } finally {
      setSaving(false);
    }
  };

  const toggleActive = async (project) => {
    try {
      await api.patch(`/projects/${project.id}/active-status`, { is_active: !project.is_active });
      toast.success(project.is_active ? "Project deactivated" : "Project activated");
      fetchProjects();
    } catch (err) {
      console.error("Toggle active error:", err);
      toast.error(err.response?.data?.message || "Failed to update status");
    }
  };

  const confirmArchive = async () => {
    if (!archiveTarget) return;
    setArchiving(true);
    try {
      await api.patch(`/projects/${archiveTarget.id}/status`, { status: "ARCHIVED" });
      toast.success("Project archived");
      setArchiveTarget(null);
      fetchProjects();
    } catch (err) {
      console.error("Archive project error:", err);
      toast.error(err.response?.data?.message || "Failed to archive project");
    } finally {
      setArchiving(false);
    }
  };

  const openDeleteModal = (project) => {
    setDeleteTarget(project);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteTarget(null);
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      await api.delete(`/projects/${deleteTarget.id}`);
      toast.success("Project deleted");
      closeDeleteModal();
      fetchProjects();
    } catch (err) {
      console.error("Delete project error:", err);
      const data = err.response?.data;
      const target = deleteTarget;
      closeDeleteModal();
      if (data?.code === "PROJECT_IN_USE") {
        toast.error("Project has dependencies. Review them before deleting.");
        setDependencyTarget(target);
        setDependencyInitialCounts(data.details?.dependents || null);
        setShowDependencyModal(true);
      } else {
        toast.error(data?.message || "Failed to delete project");
      }
    }
  };

  const closeDependencyModal = () => {
    setShowDependencyModal(false);
    setDependencyTarget(null);
    setDependencyInitialCounts(null);
  };

  const handleDependencyResolved = () => {
    fetchProjects();
    setWorkspaceRefreshTick((t) => t + 1);
  };

  const handleProjectDeletedFromDependencyModal = () => {
    closeDependencyModal();
    fetchProjects();
  };

  const handleManageModulesFromDependencyModal = (projectId) => {
    closeDependencyModal();
    openProjectWorkspace(projectId, "modules");
  };

  return (
    <div className="unit-page proj-mgmt-theme">

      <div className="project-heading-box">
        <div className="project-heading-content">
          <div className="project-heading-icon">
            <i className="fa-solid fa-diagram-project" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Configuration</div>
            <h2>{isAdmin ? "Project Management" : "My Projects"}</h2>
            <p>Manage projects, ownership and lifecycle. Task classification/assignment come in a later phase.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchProjects}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Can moduleKey="projects" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Project
            </Button>
          </Can>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card project-stat-blue">
          <div className="project-stat-content">
            <div className="proj-stat-text">
              <span>Total Projects</span>
              <strong>{total}</strong>
            </div>

            <div className="proj-stat-icon">
              <i className="fa-solid fa-folder-open" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card project-stat-purple">
          <div className="project-stat-content">
            <div className="proj-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="proj-stat-icon">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card project-stat-green">
          <div className="project-stat-content">
            <div className="proj-stat-text">
              <span>Rows Per Page</span>
              <strong>{pageSize}</strong>
            </div>

            <div className="proj-stat-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar project-toolbar">
          <div className="project-section-title">
            <div className="project-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div className="project-section-copy">
              <h5>Project List</h5>
              <p>Search, filter, add, update, activate/deactivate, archive or delete projects.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions proj-filters-row">
            <InputGroup className="unit-search proj-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search name or code..."
                aria-label="Search name or code"
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <div className="proj-select-wrap">
              <i className="fa-solid fa-circle-check proj-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="proj-filter-select"
                aria-label="Filter by status"
                value={statusFilter}
                onChange={(e) => {
                  setCurrentPage(1);
                  setStatusFilter(e.target.value);
                }}
              >
                <option value="">All Statuses</option>
                {STATUS_VALUES.map((s) => (
                  <option key={s} value={s}>{s.replace("_", " ")}</option>
                ))}
              </Form.Select>
            </div>

            <div className="proj-select-wrap">
              <i className="fa-solid fa-toggle-on proj-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="proj-filter-select"
                aria-label="Filter by active status"
              value={activeFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setActiveFilter(e.target.value);
              }}
            >
              <option value="">Active: Any</option>
              <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Form.Select>
            </div>

            <div className="proj-select-wrap">
              <i className="fa-solid fa-building proj-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="proj-filter-select"
                aria-label="Filter by department"
              value={departmentFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setDepartmentFilter(e.target.value);
              }}
            >
              <option value="">All Departments</option>
              {departments.map((d) => (
                <option key={d.id} value={d.id}>{d.name}</option>
                ))}
              </Form.Select>
            </div>

            <div className="proj-select-wrap">
              <i className="fa-solid fa-building-columns proj-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="proj-filter-select"
                aria-label="Filter by unit"
              value={unitFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setUnitFilter(e.target.value);
              }}
            >
              <option value="">All Units</option>
              {units.map((u) => (
                <option key={u.id} value={u.id}>{u.name}</option>
                ))}
              </Form.Select>
            </div>

            <div className="proj-select-wrap">
              <i className="fa-solid fa-user-tie proj-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="proj-filter-select"
                aria-label="Filter by owner"
              value={ownerFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setOwnerFilter(e.target.value);
              }}
            >
              <option value="">All Owners</option>
              {users.map((u) => (
                <option key={u.id} value={u.id}>{u.name}</option>
                ))}
              </Form.Select>
            </div>

            <Form.Select
              className="unit-page-size"
              aria-label="Rows per page"
              value={pageSize}
              onChange={(e) => {
                setCurrentPage(1);
                setPageSize(Number(e.target.value));
              }}
            >
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading projects...</p>
            </div>
          ) : (
            <Table responsive className="unit-table">
              <colgroup>
                <col className="pm-col-sno" />
                <col className="pm-col-name" />
                <col className="pm-col-code" />
                <col className="pm-col-owner" />
                <col className="pm-col-dept" />
                <col className="pm-col-unit" />
                <col className="pm-col-status" />
                <col className="pm-col-members" />
                <col className="pm-col-modules" />
                <col className="pm-col-active" />
                <col className="pm-col-actions" />
              </colgroup>
              <thead>
                <tr>
                  <th className="pm-th-center">S.NO.</th>
                  <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>
                  <th className="sortable" onClick={() => handleSort("code")}>Code {sortIcon("code")}</th>
                  <th>Owner</th>
                  <th>Department</th>
                  <th>Unit</th>
                  <th className="sortable pm-th-center" onClick={() => handleSort("status")}>Status {sortIcon("status")}</th>
                  <th className="pm-th-center">Members</th>
                  <th className="pm-th-center">Modules</th>
                  <th className="sortable pm-th-center" onClick={() => handleSort("is_active")}>Active {sortIcon("is_active")}</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                {loadError ? (
                  <tr>
                    <td colSpan="11">
                      <div className="unit-empty unit-empty-error">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
                        </div>
                        <h5>Couldn't load projects</h5>
                        <p>{loadError}</p>
                        <Button className="unit-btn unit-btn-light" onClick={fetchProjects}>
                          <i className="fa-solid fa-rotate-right" aria-hidden="true"></i>
                          Retry
                        </Button>
                      </div>
                    </td>
                  </tr>
                ) : projects.length > 0 ? (
                  projects.map((project, index) => {
                    const isExpanded = String(expandedProjectId) === String(project.id);
                    return (
                  <React.Fragment key={project.id}>
                    <tr className={isExpanded ? "project-row-selected" : ""}>
                      <td>{getSerialNumber(index, currentPage, pageSize)}</td>
                      <td>
                        <div className="project-name-box">
                          <div className="project-letter">
                            {project.name?.charAt(0)?.toUpperCase() || "P"}
                          </div>

                          <div className="project-name-copy">
                            <Button
                              variant="link"
                              className="p-0 proj-name-link"
                              onClick={() => openProjectWorkspace(project.id, "overview")}
                            >
                              <strong>{project.name}</strong>
                            </Button>
                            <small>Project ID: {project.id}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        {project.code ? (
                          <span className="project-code-chip">
                            <i className="fa-solid fa-code" aria-hidden="true"></i>
                            {project.code}
                          </span>
                        ) : (
                          <span className="proj-muted">—</span>
                        )}
                      </td>
                      <td>
                        {project.owner_name ? (
                          <span className="project-owner-chip">
                            <i className="fa-regular fa-user" aria-hidden="true"></i>
                            {project.owner_name}
                          </span>
                        ) : (
                          <span className="proj-muted">Unassigned</span>
                        )}
                      </td>
                      <td>
                        {project.department_name ? (
                          <span className="project-department-chip">
                            <i className="fa-solid fa-building" aria-hidden="true"></i>
                            {project.department_name}
                          </span>
                        ) : (
                          <span className="proj-muted">—</span>
                        )}
                      </td>
                      <td>
                        {project.unit_name ? (
                          <span className="project-unit-chip">
                            <i className="fa-solid fa-building-columns" aria-hidden="true"></i>
                            {project.unit_name}
                          </span>
                        ) : (
                          <span className="proj-muted">Global</span>
                        )}
                      </td>
                      <td>
                        <Badge
                          bg={statusColor(project.status)}
                          className={`project-lifecycle-status project-status-${String(
                            project.status || ""
                          ).toLowerCase()}`}
                        >
                          {String(project.status || "").replace("_", " ")}
                        </Badge>
                      </td>
                      <td className="proj-col-count">
                        <span
                          className="project-count-chip project-count-clickable"
                          role="button"
                          tabIndex={0}
                          title="View project members"
                          onClick={() => openProjectWorkspace(project.id, "members")}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              openProjectWorkspace(project.id, "members");
                            }
                          }}
                        >
                          <i className="fa-solid fa-users" aria-hidden="true"></i>
                          {project.active_member_count ?? 0}
                        </span>
                      </td>
                      <td className="proj-col-count">
                        <span
                          className="project-count-chip project-count-modules project-count-clickable"
                          role="button"
                          tabIndex={0}
                          title="View project modules"
                          onClick={() => openProjectWorkspace(project.id, "modules")}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              openProjectWorkspace(project.id, "modules");
                            }
                          }}
                        >
                          <i className="fa-solid fa-cubes" aria-hidden="true"></i>
                          {project.active_module_count ?? 0}
                        </span>
                      </td>
                      <td>
                        <Badge
                          className={`project-active-badge ${
                            project.is_active
                              ? "project-active-badge-on"
                              : "project-active-badge-off"
                          }`}
                        >
                          <i
                            className={
                              project.is_active
                                ? "fa-solid fa-circle-check me-1"
                                : "fa-solid fa-circle-pause me-1"
                            }
                            aria-hidden="true"
                          ></i>
                          {project.is_active ? "Active" : "Inactive"}
                        </Badge>
                      </td>
                      <td>
                        <div className="unit-actions action-container">
                          <Button
                            className={`unit-icon-btn project-view ${isExpanded ? "project-view-active" : ""}`}
                            title={isExpanded ? "Collapse workspace" : "View project workspace"}
                            aria-label={isExpanded ? "Collapse project workspace" : "View project workspace"}
                            aria-expanded={isExpanded}
                            onClick={() => toggleProjectWorkspace(project.id)}
                          >
                            <i className={`fa-solid ${isExpanded ? "fa-chevron-up" : "fa-eye"}`} aria-hidden="true"></i>
                          </Button>

                          <Button
                            className="unit-icon-btn project-workspace"
                            title="Open full project workspace (Overview/Process/Board/Timeline/Milestones/Activity)"
                            aria-label={`Open full workspace for ${project.name || "project"}`}
                            onClick={() => navigate(`${basePath}/projects/${project.id}`)}
                          >
                            <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
                          </Button>

                          <Can moduleKey="projects" actionKey="edit">
                            <Button
                              className="unit-icon-btn unit-edit"
                              title="Edit"
                              aria-label="Edit project"
                              onClick={() => openEdit(project)}
                            >
                              <i className="fa-solid fa-pen" aria-hidden="true"></i>
                            </Button>
                          </Can>

                          {(can("projects", "activate") || can("projects", "deactivate")) && (
                            <Button
                              className={`unit-icon-btn proj-toggle ${
                                project.is_active
                                  ? "project-toggle-off"
                                  : "project-toggle-on"
                              }`}
                              title={project.is_active ? "Deactivate" : "Activate"}
                              aria-label={project.is_active ? "Deactivate project" : "Activate project"}
                              onClick={() => toggleActive(project)}
                            >
                              <i className={`fa-solid ${project.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
                            </Button>
                          )}

                          <Can moduleKey="projects" actionKey="archive">
                            {project.status !== "ARCHIVED" && (
                              <Button
                                className="unit-icon-btn proj-archive"
                                title="Archive"
                                aria-label="Archive project"
                                onClick={() => setArchiveTarget(project)}
                              >
                                <i className="fa-solid fa-box-archive" aria-hidden="true"></i>
                              </Button>
                            )}
                          </Can>

                          <Can moduleKey="projects" actionKey="delete">
                            <Button
                              className="unit-icon-btn unit-delete"
                              title="Delete"
                              aria-label="Delete project"
                              onClick={() => openDeleteModal(project)}
                            >
                              <i className="fa-solid fa-trash" aria-hidden="true"></i>
                            </Button>
                          </Can>
                        </div>
                      </td>
                    </tr>

                    {isExpanded && (
                      <tr className="project-workspace-row">
                        <td colSpan="11">
                          <div className="projdetail-theme project-inline-workspace">
                            <ProjectDetailPanel
                              key={`workspace-${project.id}-${workspaceRefreshTick}`}
                              projectId={project.id}
                              activeTab={expandedTab}
                              onTabChange={handleWorkspaceTabChange}
                              onCollapse={collapseProjectWorkspace}
                              onProjectChanged={fetchProjects}
                            />
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="11">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-diagram-project" aria-hidden="true"></i>
                        </div>
                        <h5>No projects found</h5>
                        <p>Try another search or add a new project.</p>

                        <Can moduleKey="projects" actionKey="create">
                          <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                            Add Project
                          </Button>
                        </Can>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing <strong>{projects.length}</strong> of <strong>{total}</strong> projects
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </Pagination.Item>
              )), currentPage)}
              <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        className="unit-modal"
        size="lg"
        dialogClassName="project-admin-modal project-admin-modal-lg"
        backdropClassName="project-admin-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="project-modal-heading">
            <div className="project-modal-icon">
              <i
                className={
                  editId
                    ? "fa-solid fa-pen-to-square"
                    : "fa-solid fa-diagram-project"
                }
                aria-hidden="true"
              ></i>
            </div>

            <div>
              <small>Project Setup</small>
              <Modal.Title>{editId ? "Edit Project" : "Add New Project"}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Label>Name</Form.Label>
              <div className="project-modal-field">
                <i className="fa-solid fa-diagram-project" aria-hidden="true"></i>
                <Form.Control
                  placeholder="e.g. Website Revamp"
                  value={form.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-6">
              <Form.Label>Code (optional — derived from name if blank)</Form.Label>
              <div className="project-modal-field">
                <i className="fa-solid fa-code" aria-hidden="true"></i>
                <Form.Control
                  placeholder="e.g. WEB_REVAMP"
                  value={form.code}
                  onChange={(e) => handleChange("code", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-12">
              <Form.Label>Description</Form.Label>
              <div className="project-modal-field project-modal-field-textarea">
                <i className="fa-regular fa-note-sticky" aria-hidden="true"></i>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={form.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-6">
              <Form.Label>Owner (optional)</Form.Label>
              <div className="project-owner-picker-wrap">
                <ProjectMemberPicker
                  users={users}
                  value={form.owner_user_id}
                  onChange={(id) => handleChange("owner_user_id", id)}
                  placeholder="Select project owner..."
                />
              </div>
              <Form.Text muted>
                The owner is automatically given an active OWNER membership on this project.
              </Form.Text>
            </div>

            <div className="col-md-3">
              <Form.Label>Department (optional)</Form.Label>
              <Form.Select value={form.department_id} onChange={(e) => handleChange("department_id", e.target.value)}>
                <option value="">Unclassified</option>
                {departments.map((d) => (
                  <option key={d.id} value={d.id}>{d.name}</option>
                ))}
              </Form.Select>
            </div>

            <div className="col-md-3">
              <Form.Label>Unit (optional)</Form.Label>
              <Form.Select value={form.unit_id} onChange={(e) => handleChange("unit_id", e.target.value)}>
                <option value="">Global</option>
                {units.map((u) => (
                  <option key={u.id} value={u.id}>{u.name}</option>
                ))}
              </Form.Select>
            </div>

            <div className="col-md-6">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                className="project-date-input"
                type="date"
                value={form.start_date}
                onChange={(e) => handleChange("start_date", e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <Form.Label>End Date</Form.Label>
              <Form.Control
                className="project-date-input"
                type="date"
                value={form.end_date}
                onChange={(e) => handleChange("end_date", e.target.value)}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Project" : "Create Project"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={closeDeleteModal}
        centered
        className="unit-modal"
        dialogClassName="project-admin-modal project-admin-modal-sm project-admin-modal-danger"
        backdropClassName="project-admin-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="project-modal-heading">
            <div className="project-modal-icon project-modal-icon-danger">
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </div>

            <div>
              <small>Delete Action</small>
              <Modal.Title>Delete Project?</Modal.Title>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="project-modal-danger-visual" aria-hidden="true">
            <i className="fa-solid fa-diagram-project"></i>
          </div>
          <p className="unit-delete-text text-center">
            Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
            If members or modules reference it, deletion will be blocked — archive or deactivate instead.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmModal
        show={!!archiveTarget}
        onHide={() => setArchiveTarget(null)}
        onConfirm={confirmArchive}
        busy={archiving}
        title="Archive Project?"
        message={`Archive project "${archiveTarget?.name}"? Archived projects are kept for history but treated as closed.`}
        confirmLabel="Archive"
        confirmVariantClass="unit-btn-primary"
        dialogClassName="project-admin-modal project-admin-modal-sm project-archive-modal"
        icon={<i className="fa-solid fa-box-archive" aria-hidden="true"></i>}
        iconClassName="project-modal-archive-visual"
      />

      <ProjectDependencyModal
        show={showDependencyModal}
        project={dependencyTarget}
        initialCounts={dependencyInitialCounts}
        onHide={closeDependencyModal}
        onDeleted={handleProjectDeletedFromDependencyModal}
        onDependencyChanged={handleDependencyResolved}
        onManageModules={handleManageModulesFromDependencyModal}
      />
    </div>
  );
}